<template>
  <div class="headerTop">
    <div class="aaa">
      <img style="width: 138px; height: 35px" src="../assets/wzy.png" alt="" />
      <div @click="link(1)">产品</div>
      <div @click="link(2)">关于我们</div>
      <!-- <div @click="link(3)">付费资讯</div> -->
    </div>
    <div @click="login()" style="font-size: 20px">
      <a href="https://pc.pkbeds.com">登录</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerTop",
  props: {
    msg: String,
  },
  methods: {
    link(x) {
      if (x == 1) {
        const element = document.getElementById("target-element");
        element.scrollIntoView({ behavior: "smooth" });
      } else if (x == 2) {
        const element = document.getElementById("target-element2");
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        const element = document.getElementById("target-element3");
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    login() {
      // window.localStorage.href = 'http://pc.wanzicloud.com'
    },
  },
};
</script>

<style scoped>
.headerTop {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 60px;
  position: absolute;
  padding-top: 20px;
  box-sizing: border-box;
}
.headerTop img {
  width: 110px;
  height: 40px;
  margin-right: 137px;
}
div {
  font-weight: 400;
  font-size: 15.17px;
  color: #ffffff;
  margin-right: 90px;
  cursor: pointer;
}
.aaa {
  display: flex;
  align-items: center;
}
a {
  color: #ffffff;
  text-decoration: none;
}
</style>
